import { FlashCommand, FlashMode } from '../Types';

export const commandToBinary = (command: FlashCommand, mode: FlashMode) => {
    let commandString = "";
    if(command.command === 'channelSelect') {

        if(typeof command.data === 'number') {
            console.warn('Channel Select must be an array');
            return;
        }

        commandString = "10";

        if (Array.isArray(command.data) && [1, 2, 3, 4, 7].some(num => (command.data as number[]).includes(num))) {
            commandString += "01";
        } else if (Array.isArray(command.data) && [5, 8].some(num => (command.data as number[]).includes(num))) {
            commandString += "10";
        }

        const pairs = [
            [4, 4],
            [3, 3],
            [2, 2],
            [1, 5]
        ];

        commandString += pairs.map(([a, b]) => (Array.isArray(command.data) && (command.data.includes(a) || command.data.includes(b)) ? "1" : "0")).join("");
        
    } else if(command.command === 'timeByte') {
        commandString = "01";

        if(typeof command.data !== 'number') {
            console.warn('Channel Select must be a number');
            return;
        } else if(command.data < 0) {
            console.warn('Time Byte must be more than 0');
            return;
        }

        let duration = command.data;
        // Adjust duration based on speed, round to nearest 10
        if(mode.config?.speed) duration = Math.round((duration / mode.config.speed) / 10) * 10;
        // Ensure duration is at least 10
        if(duration < 10) duration = 10;

        if(duration >= 310) {
            commandString += "1";
            duration = Math.round(duration / 100)
        } else {
            commandString += "0";
            duration = Math.round(duration / 10)
        }

        // Convert to binary
        commandString += duration.toString(2).padStart(5, '0');
    } else if(command.command === 'PWM') {
        commandString = "00";

        if(typeof command.data !== 'number') {
            console.warn('PWM must be a number');
            return;
        }

        let brightness = command.data;
        if(mode?.config?.brightness) brightness *= mode.config.brightness;
        // Convert to binary
        commandString += Math.round((Math.min(brightness, 100) / 100) * 63).toString(2).padStart(6, '0');
    } else if (command.command === 'interruptible') {
        commandString = "1100000";

        if(typeof command.data !== 'number') {
            console.warn('Data must be a number', command.data);
            return;
        }

        commandString += command.data;
    }

    // console.log("Command: " + command.command + " - Binary: " + commandString + " - Decimal: " + parseInt(commandString, 2), command.data);
    return commandString;
}

export const binaryToCommand = (binary: string) => {
    if(binary.length < 8) {
        console.warn('Binary command must be at least 8 bits');
        return;
    }

    const command: any = {
        command: '',
        data: []
    };

    if(binary.startsWith('10')) {
        command.command = 'channelSelect';
        const channels: number[] = [];
        if(binary[2] === '0') {
            if(binary[4] === '1') channels.push(4);
            if(binary[5] === '1') channels.push(3);
            if(binary[6] === '1') channels.push(2);
            if(binary[7] === '1') channels.push(1);
        } else if(binary[2] === '1') {
            if(binary[7] === '1') {
                channels.push(5);
            }
        }
        command.data = channels;
    } else if(binary.startsWith('01')) {
        command.command = 'timeByte';
        const duration = parseInt(binary.slice(3, 8), 2);
        command.data = duration * (binary[2] === '1' ? 100 : 10) + 'ms';
    } else if(binary.startsWith('00')) {
        command.command = 'PWM';
        const brightness = parseInt(binary.slice(2, 8), 2);
        command.data = Math.round((brightness / 63) * 100) + '%';
    } else if(binary.startsWith('1100000')) {
        command.command = 'interruptible';
        command.data = binary.slice(7) === '1' ? 'No' : 'Yes';
    }

    return command;
}